import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router-dom";
import { Card, List, Switch } from "antd";
import Loading from "../../../../components/Loading";
import { createLoadingSelector } from "../../../../store/api/selectors";
import { getListConfiguration, putConfiguration } from "./actions";
import { getProducts } from "../../Classify/PisCofins/actions";
import { getProducts as getProductsIcms } from "../../Classify/Icms/actions";
import { getResults } from "../../Result/actions";

function Configuration(props) {
  const [icmsModule] = useState(
    JSON.parse(sessionStorage.getItem("icmsModule"))
  );
  const [update, setUpdate] = useState(true);
  const {
    isFetching,
    getListConfiguration,
    list,
    desabilitarOpcoesConfiguracao,
    match: {
      params: { cnpj },
    },
  } = props;

  useEffect(() => {
    setUpdate(true);
    if (update) {
      getListConfiguration();
      setUpdate(false);
    }
  }, [list, cnpj]);

  async function updateConfiguration(e, item) {
    const data = {
      ...item,
      Status: e,
    };
    await props.putConfiguration(data);
    if (item.Codigo === 6) {
      props.getProducts();
      if (icmsModule) props.getProductsIcms();
      props.getResults();
    }
  }

  return (
    <>
      {isFetching ? <Loading /> : null}
      <Card
        title="Configurações"
        bordered={false}
        className="configuration mb-3"
      >
        <List
          dataSource={list}
          renderItem={(item) => (
            <List.Item key={item.Codigo}>
              {item.Descricao}
              <Switch
                disabled={desabilitarOpcoesConfiguracao}
                checkedChildren="Sim"
                unCheckedChildren="Não"
                checked={item.Status}
                loading={isFetching ? true : false}
                onChange={(e) => updateConfiguration(e, item)}
              />
            </List.Item>
          )}
        />
      </Card>
    </>
  );
}

const loadingGetConfiguration = createLoadingSelector([
    "GET_LIST_CONFIGURATION",
  ]),
  loadingPutConfiguration = createLoadingSelector(["PUT_CONFIGURATION"]);
const mapStateToProps = (state) => ({
  list: state.config.list,
  isFetching: loadingGetConfiguration(state) || loadingPutConfiguration(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getListConfiguration,
      putConfiguration,
      getProducts,
      getProductsIcms,
      getResults,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Configuration));
